import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import userAvatar from "../../assets/images/user-avater.png";

const InvestorContainer = ({
  investors = [],
  investorsPageData,
  handlePageChange,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [btnArray, setBtnArray] = useState([]);
  const [displayedInvestors, setDisplayedInvestors] = useState([]);

  // Get query params from URL for pagination
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const page = parseInt(queryParams.get("page")) || 1;
    setCurrentPage(page);

    // Calculate total pages if not provided
    if (investors && investors.length > 0) {
      const totalPages = investorsPageData?.totalPages; // Assuming 10 investors per page
      setTotalPages(totalPages);
      generatePaginationButtons(page, totalPages);

      // // Apply pagination to displayed investors
      // const startIndex = (page - 1) * 10;
      // const endIndex = startIndex + 10;
      // setDisplayedInvestors(investors.slice(startIndex, endIndex));
      setDisplayedInvestors(investors);
    } else {
      setDisplayedInvestors([]);
      setTotalPages(0);
      setBtnArray([]);
    }
  }, [investors]);

  // Generate pagination buttons logic
  const generatePaginationButtons = (current, total) => {
    console.log("Page Generate", current, total);
    let buttons = [];

    if (total <= 7) {
      // Show all pages if total is 7 or less
      for (let i = 1; i <= total; i++) {
        buttons.push(i);
      }
    } else {
      // Complex pagination with ellipsis
      if (current <= 3) {
        buttons = [1, 2, 3, 4, 5, "...", total];
      } else if (current >= total - 2) {
        buttons = [1, "...", total - 4, total - 3, total - 2, total - 1, total];
      } else {
        buttons = [1, "...", current - 1, current, current + 1, "...", total];
      }
    }

    setBtnArray(buttons);
  };

  if (!displayedInvestors || displayedInvestors.length === 0) {
    return (
      <div className="flex items-center justify-center h-[300px]">
        <p className="text-gray-500">No investors found</p>
      </div>
    );
  }

  return (
    <div id="investor-container" className="flex flex-col gap-8">
      {/* Investor list */}
      {displayedInvestors.map((investor, index) => {
        // Ensure investor has a valid key property
        const investorKey = investor?.id || investor?.slug || index;
        return (
          <div key={investorKey} className="py-6 px-3 sm:px-8 w-full">
            <div className="flex flex-col gap-4 md:flex-row justify-between md:items-center">
              <div className="flex space-x-2 md:space-x-4 items-center">
                <Link to={investor?.slug ? `/investor/${investor.slug}` : "#"}>
                  <img
                    className="w-14 h-14 sm:w-16 sm:h-16 object-contain rounded-full"
                    src={investor?.image || userAvatar}
                    alt="Investor"
                  />
                </Link>
                <div className="space-y-1">
                  <Link
                    to={investor?.slug ? `/investor/${investor.slug}` : "#"}
                  >
                    <h1 className="font-semibold text-[16px] text-white">
                      {investor?.prefix && `${investor.prefix} `}
                      {investor?.first_name || ""} {investor?.last_name || ""}
                      {investor?.suffix && ` ${investor.suffix}`}
                    </h1>
                    <p className="text-gray-500 text-sm text-white">
                      {investor?.job_title || "Investor"}
                    </p>
                  </Link>
                </div>
              </div>
            </div>
            <p className="my-4 text-sm">
              {investor?.user?.userprofile?.bio &&
                `"${investor.user.userprofile.bio}"`}
            </p>
            <div className="border rounded-md border-[#2d6bd8] py-4 bg-[#1c1b29]">
              <h2 className="text-[15px] text-white pb-2 border-b border-[#2d6bd8] px-6 font-medium text-uppercase">
                Details
              </h2>

              <div className="p-5 text-white">
                {/* Details fields */}
                {[
                  { label: "Firm name", value: investor?.firm_name },
                  { label: "Work email", value: investor?.work_email },
                  { label: "Address 1", value: investor?.address_1 },
                  { label: "Address 2", value: investor?.address_2 },
                  { label: "City", value: investor?.city },
                  { label: "State", value: investor?.state },
                  { label: "Zip", value: investor?.zip },
                  { label: "Country", value: investor?.country },
                  { label: "Phone", value: investor?.phone },
                  { label: "Email", value: investor?.email },
                  {
                    label: "Website",
                    value: investor?.website,
                    isLink: true,
                  },
                  { label: "Subject", value: investor?.subject },
                ].map(
                  (detail, idx) =>
                    detail.value && (
                      <div key={idx} className="flex gap-3">
                        <div className="min-w-[100px] font-semibold whitespace-nowrap">
                          {detail.label}
                        </div>
                        <div>:</div>
                        <div
                          className={
                            detail.isLink || detail.value.includes("@")
                              ? "overflow-x-auto"
                              : ""
                          }
                        >
                          {detail.isLink ? (
                            <a
                              href={detail.value}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {detail.value}
                            </a>
                          ) : (
                            detail.value
                          )}
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        );
      })}

      {/* Pagination */}
      {totalPages > 1 && (
        <ol className="flex justify-center gap-1 text-xs font-medium my-8">
          {/* First page button */}
          {currentPage > 1 && (
            <li>
              <button
                onClick={() => handlePageChange(1)}
                className="inline-flex size-8 items-center justify-center hover:bg-[#fbbb04] hover:text-white rounded-full border border-gray-100 bg-white text-gray-900"
              >
                <span className="sr-only">First Page</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </li>
          )}

          {/* Page numbers */}
          {btnArray.map((item, idx) => (
            <li key={idx}>
              {item === "..." ? (
                <div className="block size-8 rounded-full border-gray-100 border text-center leading-8 text-primary">
                  {item}
                </div>
              ) : parseInt(item) === currentPage ? (
                <div className="block size-8 rounded-full border-[#fbbb04] bg-[#fbbb04] text-center leading-8 text-white">
                  {item}
                </div>
              ) : (
                <button
                  onClick={() => handlePageChange(parseInt(item))}
                  className="block size-8 hover:bg-[#fbbb04] hover:text-white rounded-full border border-gray-100 bg-white text-center leading-8 text-gray-900"
                >
                  {item}
                </button>
              )}
            </li>
          ))}

          {/* Last page button */}
          {currentPage < totalPages && (
            <li>
              <button
                onClick={() => handlePageChange(totalPages)}
                className="inline-flex size-8 items-center justify-center hover:bg-[#fbbb04] hover:text-white rounded-full border border-gray-100 bg-white text-gray-900"
              >
                <span className="sr-only">Last Page</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </li>
          )}
        </ol>
      )}
    </div>
  );
};

export default InvestorContainer;
